<template>
  <v-dialog persistent v-model="returnDialog" width="720px">
    <v-card>
      <v-card-title>
          <span class="headline">
            {{ $t("HuifuPay.Return.title") }}
          </span>
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="returnDialog = false">
              fa-times
            </v-icon>
          </template>
          <span>
              {{ $t("CRUD.backToList", [$t("HuifuPay.title")]) }}
            </span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <v-container>
           <ValidationObserver ref="observer">
          <v-form>
            <v-row>
                <!-- 收款账户(原付款账户 ) -->
                <v-col cols="6">
                  <span >
                    {{ $t("HuifuPay.Return.inExtCode") + $t("Global.colon") }}
                  </span>
                    <span class="green--text">
                  {{ huifuAccount.out_ext_code }}
                  </span>
                    <span class="red--text">
                  {{ $t("HuifuPay.Return.returnCode") }}
                  </span>
                </v-col>
                <!-- 账户余额 -->
                <v-col cols="6">
                  <span>
                    {{ $t("HuifuPay.Return.balanceAmt") }}{{ $t("Global.colon") }}
                  </span>
                    <span class="red--text">
                   {{ $t("Global.money")
                    }}{{ huifuAccount.ord_amt - huifuAccount.return_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 出款账户 -->
                <v-col cols="6">
                  <span >
                    {{ $t("HuifuPay.Return.outExtCode") + $t("Global.colon") }}
                  </span>
                    <span class="green--text">
                  {{ huifuAccount.in_ext_code }}
                  </span>
                </v-col>
                <!-- 出款公司 -->
                <v-col cols="6">
                  <span >
                    {{ $t("HuifuPay.Return.companyName") + $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                  {{ (huifuAccount.third_account_info && huifuAccount.third_account_info.company_name) ? huifuAccount.third_account_info.company_name : '' }}
                  </span>
                </v-col>
                <!-- 退款金额-->
                <v-col cols="6">
                    <ValidationProvider
                            v-slot="{ errors }"
                            :name="$t('HuifuPay.Return.returnPay')"
                            :rules="{
                                    max_value: {
                                        max: (huifuAccount.ord_amt - huifuAccount.return_price).toFixed(2),
                                    },
                                    min_value: {
                                        min: 0.01,
                                    },
                                    required: {
                                        required: true
                                    }
                                }"
                    >
                    <span class="d-flex">
                    {{ $t("HuifuPay.Return.returnPay") }}{{ $t("Global.colon") }}
                    <v-text-field
                            v-model="returnPay"
                            single-line
                            dense
                            type="number"
                            min="0"
                            :disabled="isReturnPayDisabled"
                            :prefix="$t('Global.money')"
                            :error-messages="errors"
                            @blur="returnPay = $numberFormatter.formatMoney(returnPay)"
                    ><template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                    </span>
                    </ValidationProvider>
                </v-col>
                <!-- 验证码 -->
                <v-col cols="6" v-if="isReturnPayDisabled">
                  <span class="d-flex">
                    {{ $t("HuifuPay.Return.VCode") }}{{ $t("Global.colon") }}
                    <v-text-field
                            v-model="VCode"
                            single-line
                            dense
                            persistent-hint
                            :hint="$t('HuifuAccount.vc_code_hint')"
                    />
                  </span>
                </v-col>
            </v-row>
          </v-form>
           </ValidationObserver>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="returnDialog = false">{{ $t("$vuetify.close") }}</v-btn>
        <v-btn color="accent" @click="submit()">{{ $t("CRUD.confirm") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";
import HfdgInterface from "@/api/hfdgInterface";
import ThirdAccountInfo from "@/api/third-account-info"
import { ValidationObserver, ValidationProvider } from "vee-validate";


export default {
    name: "ReturnDialog",

    props: {
        value: Boolean,
        item: Object
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data: () => ({
        returnDialog: false,
        huifuAccount: {},
        baseHuifuId: "",
        returnPay: null,
        VCode: null,
        returnCode: null,
        isReturnPayDisabled: false,
    }),
    mounted() {

    },
    methods: {
        submit() {
            if (!this.isReturnPayDisabled) {
                this.$refs.observer.validate().then(
                    async function (result) {
                        if (result) {
                            let submitData = {
                                balance_return_pay: this.returnPay,
                                pay_type: 102, // TODO 支付类型：退款：102（暂时）
                                pay_code: this.huifuAccount.pay_code
                            }
                            ThirdAccountInfo.addHfdgReturnBalance(submitData).then((payResponse) => {
                                if (payResponse.data.status.isOK()) {
                                    this.returnCode = payResponse.data.third_pay_records.pay_code
                                    if (payResponse.data.mobile_validation_flg && payResponse.data.mobile_validation_code != '') {
                                        let submitData = {
                                            return_code: this.returnCode,
                                            validation_code: payResponse.data.mobile_validation_code
                                        }
                                        HfdgInterface.balanceReturn(submitData).then(
                                            function (response) {
                                                if (response.data.status.isOK()) {
                                                    this.$snackbar.success(i18n.t("HuifuPay.Return.successMsg"));
                                                    this.returnDialog = false
                                                }
                                            }.bind(this)
                                        )
                                    } else {
                                        ThirdAccountInfo.mobileValidation({third_record_code: this.returnCode, type: 3}).then((response) => {
                                            if (response.data.status.isOK()) {
                                                this.$snackbar.success(i18n.t("HuifuPay.Return.mobileVCode"));
                                                this.isReturnPayDisabled = true
                                            }
                                        })
                                    }
                                }
                            })
                        }
                    }.bind(this)
                )
            }else if (this.VCode != '') {
                let submitData = {
                    return_code: this.returnCode,
                    validation_code: this.VCode
                }
                HfdgInterface.balanceReturn(submitData).then(
                    function (response) {
                        if (response.data.status.isOK()) {
                            this.$snackbar.success(i18n.t("HuifuPay.Return.successMsg"));
                            this.returnDialog = false
                        }
                    }.bind(this)
                )
            }
        },
    },

    watch: {
        value: {
            immediate: false, //初始赋值也调用
            handler() {
                if (!this.value) {
                    this.baseHuifuId = "";
                    this.returnPay = null;
                    this.VCode = null;
                    this.returnCode = null;
                    this.isReturnPayDisabled = false;
                }
                this.returnDialog = this.value;
            },
        },
        item: {
            immediate: false, //初始赋值也调用
            handler() {
                this.huifuAccount = this.item;
            },
        },
        returnDialog: {
            handler() {
                this.$emit("input", this.returnDialog);
            },
        },
    },
};
</script>